import { isEmpty } from 'lodash';
import { FC } from 'react';
import { IntlShape } from 'react-intl';

import LegalNotice from './LegalNotice';

import PriceTableText from './PriceTableText';

import { useMedia } from '../../../context/InterfaceContext';
import Divider from '../../shared/Divider';
import { Cell, Col, Table } from '../../shared/table';

const PricingDetails: FC<{
    data: Array<{ label: string; value: string; values: string[] }> | null;
    intl: IntlShape;
    pricingText: Array<{ href: string; text: string; title: string }> | null;
}> = ({ data, intl, pricingText }) => {
    const { isMobileOrTablet } = useMedia();
    const padding = `0 ${isMobileOrTablet ? 20 : 30}px`;

    if (!!data && !isEmpty(data)) {
        return (
            <>
                <section className="product-page__pricing-details-wrapper">
                    <h3>{intl.formatMessage({ id: 'product.pricingDetailsTitle', defaultMessage: 'Preise' })}</h3>

                    <div>
                        <Table w={'100%'} fd={'row'}>
                            {data.map(({ label, values }, index) => (
                                <Col key={label} styles={{ alignItems: index === 0 ? 'flex-start' : 'flex-end' }}>
                                    <Cell styles={{ padding, whiteSpace: 'nowrap' }} fw={700}>
                                        {label}
                                    </Cell>

                                    <Divider size={2} margin={0} />

                                    {values.map(value => (
                                        <Cell key={value} styles={{ padding, whiteSpace: 'nowrap' }}>
                                            {value}
                                        </Cell>
                                    ))}
                                </Col>
                            ))}
                        </Table>
                    </div>
                </section>

                {pricingText?.map((text, idx) => (
                    <PriceTableText priceText={text} key={`pricingText-${idx}`} />
                ))}

                <LegalNotice />
            </>
        );
    }

    return null;
};

export default PricingDetails;
